import cn from 'classnames'
import settings from '../../settings'

import { useLanguageMenu } from 'mmfintech-checkout-commons'

import { ArrowDownIcon, ArrowUpIcon } from '@icons'

import './languageMenu.scss'

const LanguageMenu = () => {
  const {
    dropdownOpened,
    selectedLanguage,
    languages,
    getLanguageName,
    handleDropDownClick,
    handleLanguageChange,
    setRef
  } = useLanguageMenu(settings.languages)

  return selectedLanguage ? (
    <div className='language-menu-wrapper' data-test='language-menu-wrapper' ref={setRef}>
      <div className={cn('language-menu-container', { opened: dropdownOpened })} onClick={handleDropDownClick}>
        <span className='selected'>{getLanguageName(selectedLanguage)}</span>
        <span className='arrow'>{dropdownOpened ? <ArrowUpIcon /> : <ArrowDownIcon />}</span>
      </div>
      <div className={cn('language-menu-dropdown', { opened: dropdownOpened })} data-test='language-menu-content'>
        <ul data-test='language-menu-list'>
          {languages.map(language => (
            <li key={language.code} onClick={() => handleLanguageChange(language.code)} data-test='language-menu-item'>
              {language.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null
}

export default LanguageMenu
